import { useContext, useEffect, useCallback, useState } from 'react';
import { CartContext } from '../../store/CartContext';
import useBrand from '../../hooks/useBrand';
import { useNavigate } from 'react-router';
// import CouponField from './CouponField';

// ESlint complains about prop-types, you need to define it
import PropTypes from 'prop-types';
CheckoutBtn.propTypes = {
  label: PropTypes.string,
  nextPage: PropTypes.string,
};

export default function CheckoutBtn({ label = 'Checkout Now', nextPage = null }) {
  const [cartState, cartDispatch] = useContext(CartContext);
  const isCartLoading = cartState.isLoading;
  const isUpdatingBillingInfo = cartState.isUpdatingBillingInfo;
  const isCartValid = Object.keys(cartState.validation.errors).length === 0;
  const { domain } = useBrand();

  const navigate = useNavigate();

  const VITE_APP_MODE = import.meta.env.MODE;
  const NODE_ENV = process.env.NODE_ENV.toLowerCase();
  const isDevMode = import.meta.env.DEV;

  let shopUrl = `https://dlshop.${domain}`;

  if (VITE_APP_MODE === 'localDev' && isDevMode) {
    shopUrl = `https://shop.${domain}`;
  }
  if (VITE_APP_MODE === 'staging' && isDevMode) {
    shopUrl = `https://mlshop.${domain}`;
  }

  if (NODE_ENV === 'staging') {
    shopUrl = `https://mlshop.${domain}`;
  }
  if (NODE_ENV === 'production') {
    shopUrl = `https://shop.${domain}`;
  }

  const [isClicked, setIsClicked] = useState(false);

  const viewedUpsells = cartState.userExperience.viewedUpsells;

  const checkUrl = nextPage ? nextPage : `${shopUrl}/checkout/?cartId=${cartState.cartId}`;

  const handleNextPage = useCallback(() => {
    if (isCartValid) {
      if (viewedUpsells) {
        // handle the case when nextPage is not provided, a flag that the user needs to go to the checkout page
        // use window.location.href to go to the checkout page
        if (!nextPage) {
          sessionStorage.setItem('viewCheckout', true);
          window.location.href = checkUrl;
        }
        // handle the case when nextPage is provided, a flag that the user needs to go to another page in the app
        // using navigate to go to the next page in react-router
        else {
          window.scrollTo(0, 0);
          navigate(checkUrl);
        }
      } else {
        cartDispatch({
          type: 'EXPERIENCE',
          payload: {
            showUpsellModal: true,
          },
        });
      }
    } else {
      cartDispatch({
        type: 'VALIDATION',
        payload: {
          showErrors: true,
          formTouched: true,
        },
      });
    }
  }, [isCartValid, viewedUpsells, nextPage, checkUrl, navigate, cartDispatch]);

  // this triggers the checkout or the next page navigation
  useEffect(() => {
    if (!isUpdatingBillingInfo && isClicked) {
      handleNextPage();
      setIsClicked(false);
    }
  }, [handleNextPage, isClicked, isUpdatingBillingInfo]);

  // using state to track if the button is clicked
  // so that we can wait for the user info update to finish
  // before we trigger the checkout or the next page navigation
  // this is to prevent the button from being clicked multiple times
  // or trigger the next page view if the next page url is provided
  const handleClick = (event) => {
    if (event) {
      event.preventDefault();
    }
    setIsClicked(true);
  };

  return (
    <button
      type="button"
      className={`checkout-btn btn btn-lg btn-success w-100 py-3 py-md-2 ${isCartLoading ? 'disabled' : ''} ${
        isClicked && isCartValid ? 'btn-processing' : ''
      }`}
      onClick={handleClick}
      name={label}
    >
      <span className="btn-label">{label}</span>
    </button>
  );
}
